/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TemplateData
 */
export interface TemplateData {
    /**
     * The data required to render the list item UI template 
     * @type {{ [key: string]: any; }}
     * @memberof TemplateData
     */
    listItem: { [key: string]: any; } | null;
    /**
     * The data required to render the client header UI template 
     * @type {{ [key: string]: any; }}
     * @memberof TemplateData
     */
    clientHeader: { [key: string]: any; } | null;
}

/**
 * Check if a given object implements the TemplateData interface.
 */
export function instanceOfTemplateData(value: object): value is TemplateData {
    if (!('listItem' in value) || value['listItem'] === undefined) return false;
    if (!('clientHeader' in value) || value['clientHeader'] === undefined) return false;
    return true;
}

export function TemplateDataFromJSON(json: any): TemplateData {
    return TemplateDataFromJSONTyped(json, false);
}

export function TemplateDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): TemplateData {
    if (json == null) {
        return json;
    }
    return {
        
        'listItem': json['list_item'],
        'clientHeader': json['client_header'],
    };
}

export function TemplateDataToJSON(json: any): TemplateData {
    return TemplateDataToJSONTyped(json, false);
}

export function TemplateDataToJSONTyped(value?: TemplateData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'list_item': value['listItem'],
        'client_header': value['clientHeader'],
    };
}

